export default __webpack_public_path__ + "static/Map_wrap-72c492c4b14174429a365c3019b46406.svg";